import { createAction } from 'redux-actions';

export const openNotificationsDrawerAction = createAction('DRAWERS/OPEN_NOTIFICATIONS_DRAWER');
export const setNotificationsDrawerParamsAction = createAction(
  'DRAWERS/SET_NOTIFICATIONS_DRAWER_PARAMS',
);
